import React, { Component } from "react";
import DownloadableTrailersTable from "../../components/tableComponent/downloadableTrailersTable";

class DownloadableTrailers extends Component {
  render() {
    return (
      <React.Fragment>
        <h1>Downloadable Trailers.</h1>
        <hr />
        <br />
        <DownloadableTrailersTable />
      </React.Fragment>
    );
  }
}

export default DownloadableTrailers;
